export const AUTH_METHODS = {
  OTP: "otp",
  GOOGLE: "google",
} as const;

export type AuthMethod = (typeof AUTH_METHODS)[keyof typeof AUTH_METHODS];
